// Auto generated file, do not manually modify!
// com.hotpads.rentcreditreport.web.api.RentCreditReportWebApiHandler

import type { UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentCreditReportWebApiHandler_enrollmentStatus,
  RentCreditReportWebApiHandler_enrollmentStatus_Path,
  RentCreditReportWebApiHandler_enrollmentUpdate,
  RentCreditReportWebApiHandler_get,
  RentCreditReportWebApiHandler_get_Path,
  RentCreditReportWebApiHandler_sendRequestForZillowPayments,
} from '@zg-rentals/ts-rent-credit-report-client';

import type {
  ReportingForAllEnrollmentStatusResponseDto,
  ReportingForAllEnrollmentUpdateRequestDto,
  SendRequestForZillowPaymentsWebApiRequestDto,
  UsersGetResponseDto,
} from '@zg-rentals/ts-rent-credit-report-client';

export type RentCreditReportWebApiHandler_enrollmentStatus_Options = UseQueryOptions<
  ReportingForAllEnrollmentStatusResponseDto,
  unknown,
  ReportingForAllEnrollmentStatusResponseDto,
  Array<string>
>;

const RentCreditReportWebApiHandler_enrollmentStatus_GetKey = () => [
  RentCreditReportWebApiHandler_enrollmentStatus_Path,
];

/**
 * Get rent credit reporting for all enrollment status
 */
export const useRentCreditReportWebApiHandler_enrollmentStatus = ({
  httpClient,
  ...options
}: Omit<RentCreditReportWebApiHandler_enrollmentStatus_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentCreditReportWebApiHandler_enrollmentStatus_GetKey(),
    queryFn: () => RentCreditReportWebApiHandler_enrollmentStatus(httpClient),
  });
};
useRentCreditReportWebApiHandler_enrollmentStatus.getKey = RentCreditReportWebApiHandler_enrollmentStatus_GetKey;

export interface RentCreditReportWebApiHandler_enrollmentUpdate_Args {
  postData: ReportingForAllEnrollmentUpdateRequestDto;
}

export type RentCreditReportWebApiHandler_enrollmentUpdate_Options = UseMutationOptions<
  void,
  unknown,
  RentCreditReportWebApiHandler_enrollmentUpdate_Args
>;

/**
 * Update rent credit reporting for all enrollment status
 */
export const useRentCreditReportWebApiHandler_enrollmentUpdate = ({
  httpClient,
  ...options
}: Omit<RentCreditReportWebApiHandler_enrollmentUpdate_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentCreditReportWebApiHandler_enrollmentUpdate_Args) =>
      RentCreditReportWebApiHandler_enrollmentUpdate(args.postData, httpClient),
  });
};

export type RentCreditReportWebApiHandler_get_Options = UseQueryOptions<
  UsersGetResponseDto,
  unknown,
  UsersGetResponseDto,
  Array<string>
>;

const RentCreditReportWebApiHandler_get_GetKey = () => [RentCreditReportWebApiHandler_get_Path];

/**
 * Get current logged in user info with enrollment status
 */
export const useRentCreditReportWebApiHandler_get = ({
  httpClient,
  ...options
}: Omit<RentCreditReportWebApiHandler_get_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {}) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentCreditReportWebApiHandler_get_GetKey(),
    queryFn: () => RentCreditReportWebApiHandler_get(httpClient),
  });
};
useRentCreditReportWebApiHandler_get.getKey = RentCreditReportWebApiHandler_get_GetKey;

export interface RentCreditReportWebApiHandler_sendRequestForZillowPayments_Args {
  postData: SendRequestForZillowPaymentsWebApiRequestDto;
}

export type RentCreditReportWebApiHandler_sendRequestForZillowPayments_Options = UseMutationOptions<
  void,
  unknown,
  RentCreditReportWebApiHandler_sendRequestForZillowPayments_Args
>;

/**
 * Send notification via rent-payment API
 */
export const useRentCreditReportWebApiHandler_sendRequestForZillowPayments = ({
  httpClient,
  ...options
}: Omit<RentCreditReportWebApiHandler_sendRequestForZillowPayments_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentCreditReportWebApiHandler_sendRequestForZillowPayments_Args) =>
      RentCreditReportWebApiHandler_sendRequestForZillowPayments(args.postData, httpClient),
  });
};
